import { ButtonProps } from "@chakra-ui/react";
import { useContext } from "react";

import { RanaButton } from "../../components/rana-button";
import { RanaFormContext } from "../rana-form";

interface RanaFormCancelButtonProps extends ButtonProps {
  extraOnClick?: () => void;
}

export function RanaFormCancelButton({ extraOnClick, ...rest }: RanaFormCancelButtonProps) {
  const { onCancel } = useContext(RanaFormContext);
  return (
    <RanaButton
      onClick={() => {
        onCancel();
        extraOnClick && extraOnClick();
      }}
      variant="secondary"
      {...rest}
    />
  );
}
